export default {
    black: '#04040F',
    blue: {
        base: '#0065A4',
        blue0: '#ddf2ff',
        blue5: '#0C66A5',
        blue9: '#0B255F',
    },
    grey: {
        grey0: '#F3F3F5',
        grey1: '#E7E8E9',
        grey2: '#707070',
        grey3: '#8A8A8A',
        grey4: '#4D4D4D',
        grey5: '#4D555A',
        grey6: '#1C1D1E',
        grey7: '#575756',
        grey8: '#EBECEC',
        grey9: '#E6E6E6',
        cta: '#252829',
        // Undocumented grey used in the designs.
        otherGrey: '#B1B3B5',
        borderGrey0: '#E1E1E1',
        borderGrey1: '#C8CACD',
    },
    sectors: {
        oilGasGrey: '#708A97',
        marineBlue: '#55BCCA',
        defencePurple: '#8B5EA0',
        energyGreen: '#4BA559',
        nuclearOrange: '#E3772E',
        transportRed: '#D34E55',
    },
    sectorsAlt: {
        oilGasGreen: '#00AE4D',
        marineBlue: '#16BECF',
        nuclearPurple: '#A978B4',
        defenceGrey: '#6B8D9B',
        renewableYellow: '#FFDD00',
        portsTerminalsOrange: '#F37032',
        transportRed: '#E44151',
        constructionCream: '#EDDF98',
    },
    validation: {
        invalid: '#DA291C',
        valid: '#008C15',
    },
    white: '#FFFFFF',
    yellow: {
        base: '#F2D826',
    },
    // 2025 colours SD
    new: {
        slate: '#494E55',
        midblue: '#E6E6E6',
        darkgrey: '#17191B',
        cream: '#f2f2f2',
    },
};
